import SALARIO_MINIMO_MAP, {
  getSalarioPorAno,
  getAnosDisponiveis,
} from "./apiSalarioMinimo";

// Busca o salário mínimo de um ano específico usando o provedor local
// Mantém assinatura assíncrona para não quebrar quem já consome como async
export async function getSalarioMinimo(ano) {
  const valor = getSalarioPorAno(ano);

  return {
    ano: Number(ano),
    valor,
    fonte: "PROVEDOR_LOCAL (temporário)",
    atualizadoEm: new Date().toISOString(),
  };
}

// Busca o salário mínimo do ano atual
// Se o ano atual não existir no provedor local, usa o último ano disponível
export async function getSalarioMinimoAtual() {
  const anoAtual = new Date().getFullYear();
  const anos = getAnosDisponiveis();
  const anoAlvo = anos.includes(anoAtual) ? anoAtual : Math.max(...anos);

  return getSalarioMinimo(anoAlvo);
}

// Busca um intervalo de salários mínimos entre o ano inicial e o ano final
export async function getSalarioMinimoRange(startAno, endAno) {
  const start = Number(startAno);
  const end = Number(endAno);

  const list: { ano: number; valor: number | null }[] = [];
  for (let a = start; a <= end; a++) {
    list.push({
      ano: a,
      valor: (SALARIO_MINIMO_MAP as Record<number, number>)[a] ?? null,
    });
  }

  return list;
}
